module.exports = __webpack_public_path__ + "img/infographic_star_power.e45d5c4b.png";